import apiClient from '../apiClient';
import { GET_PLACE_TYPE_URL } from '../apiUrl';

const getPlaceListApi = () => {
  return apiClient.get(GET_PLACE_TYPE_URL);
};

export default getPlaceListApi;
